import { LanguageCode } from '@/interfaces';

export interface IResolveEnglishOnlyTextArgs {
  isReady: boolean;
  isEnglishPage: boolean;
  // Lazy so the layer is never read (and no exposure is logged) unless the copy is going to be shown
  readParam: () => unknown;
  fallback: string;
}

// Statsig text params hold English only, so other languages always use the translated text (NEXUS-2393)
export const isEnglishLanguage = (languageCode: LanguageCode): boolean => languageCode === LanguageCode.English;

export const resolveEnglishOnlyText = ({
  isReady,
  isEnglishPage,
  readParam,
  fallback,
}: IResolveEnglishOnlyTextArgs): string => {
  if (!isReady || !isEnglishPage) return fallback;

  const value = readParam();

  return (typeof value === 'string' ? value.trim() : '') || fallback;
};
